<template>
    <ModalFormCard class="modal-default" formCSS=''>
        <template #title>
            <input type='text' class='bg-black w-full' v-model='searchText'
                placeholder='Type here to start searching' 
                @keyup='$help.delay(function() { search() }, 0)'
                ref='input'
            />
        </template>

        <template #default="{ saving, errors }">
            <div class='grid gap-y-3 p-6' v-if='results != null'>
                <div v-for='company in results'>   
                    <button class='text-15 link-text' @click='goTo("/company/"+company.id+"/company")'>{{ company.name }}</button>
                    <p class='text-grey-900 text-13 flex items-center'>
                        <span class='w-2 h-2 rounded-full block mr-1' :style="{'background': company.statusColour()}" />
                        <p>{{ company.statusCustomerFriendlyName() }}</p>
                        <p>&nbsp;- {{ company.industry?.name || 'No industry' }}</p>
                    </p>
                    <p class='text-grey-900 text-13' v-if='company.user'>
                        {{ company.user.first_name }} {{ company.user.last_name }} 
                        - {{ company.user.email.indexOf('getwork') == -1 ? company.user.email : 'No email address' }} 
                        - {{ $help.e164ToNumber(company.user.contact_number_1) }}
                    </p>
                </div>

                <p v-if='results.length == 0' class='text-15 text-grey-900 text-center py-8'>No results found</p>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'
    import Company from '~/models/company.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                searchText: '',
                results: null
            }
        },

        created() {
            setTimeout(() => {
                this.$refs.input.focus()
            }, 20)
        },

        methods: {
            search() {
				if (this.searchText == '') {
					this.results = null
					return
				}

				this.$axios.post('/admin/actions/search', {
					search: this.searchText
				})
					.then(res => {
						this.results = Company.fill(res, {
                            vue: this.$vue
                        })
					}) 
			},

            goTo(link) {
                this.$event.$emit('modal-close')
                this.$router.push(link)
            }
        },
    }
</script>